import styled from 'styled-components'

export const Grid = styled.section`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 16px;
  @media (max-width: 1160px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 650px) { grid-template-columns: 1fr; }
`;
export const Card = styled.article`
  min-width: 0;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.colors.cardSurface};
  box-shadow: ${({ theme }) => theme.palette.colors.cardShadow};
  transition: border-color 0.18s ease, transform 0.18s ease;
  &:hover, &:focus-within { border-color: ${({ theme }) => theme.palette.colors.borderStrong}; transform: translateY(-2px); }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
export const CardHeader = styled.header`
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;
export const IdentityLogo = styled.img`
  width: auto;
  max-width: ${({ competitor }) => competitor ? '104px' : '124px'};
  height: ${({ competitor }) => competitor ? '30px' : '32px'};
  object-fit: contain;
  object-position: left center;
  border-radius: 3px;
`;
export const IdentityName = styled.span`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Poppins, sans-serif;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
`;
export const Badge = styled.span`
  padding: 4px 7px;
  border-radius: 999px;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
`;
export const CardTitle = styled.h2`
  margin: 16px 0 0;
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Gilroy, sans-serif;
  font-size: 22px;
  line-height: 1.28;
`;
export const MetaRow = styled.div`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
`;
export const DateText = styled.strong`
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Lato, sans-serif;
  font-size: 13px;
`;
export const Meta = styled.span`
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Lato, sans-serif;
  font-size: 13px;
`;
export const Summary = styled.p`
  flex: 1;
  margin: 14px 0 0;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
`;
export const CardFooter = styled.footer`
  min-height: 27px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
`;
export const SourceLink = styled.a`
  color: ${({ theme }) => theme.palette.blue.main};
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  &:hover { text-decoration: underline; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 3px; }
`;
export const LoadMore = styled.div`
  padding: 28px 0 4px;
  display: flex;
  justify-content: center;
`;
